@if (mediaList.length > 1) {
  <div class="prev-btn-wrapper">
    <div class="btn btn-round" (click)="prev()">
      <span class="mb-icon mb-icon-back-thin"></span>
    </div>
  </div>
  <div class="next-btn-wrapper">
    <div class="btn btn-round" (click)="next()">
      <span class="mb-icon mb-icon-forward-thin"></span>
    </div>
  </div>
}

<div
  class="lightbox-content-wrapper"
  (touchstart)="onTouchStart($event)"
  (touchend)="onTouchEnd($event)"
  [class.no-padding]="
    mediaList[activeIndex].mediaType === mediaType.DOCUMENT ||
    mediaList[activeIndex].mediaType === mediaType.TECHNICAL_DATA
  "
>
  @for (media of mediaList; track media.id; let index = $index) {
    @if (activeIndex === index) {
      @switch (media.mediaType) {
        @case (mediaType.IMAGE) {
          <ng-container *ngTemplateOutlet="imageTpl; context: { media: media }"></ng-container>
        }
        @case (mediaType.AUDIO) {
          <ng-container *ngTemplateOutlet="audioTpl; context: { media: media }"></ng-container>
        }
        @case (mediaType.DOCUMENT) {
          <ng-container *ngTemplateOutlet="documentTpl; context: { media: media }"></ng-container>
        }
        @case (mediaType.TECHNICAL_DATA) {
          <ng-container *ngTemplateOutlet="documentTpl; context: { media: media }"></ng-container>
        }
        @case (mediaType.VIDEO) {
          <ng-container *ngTemplateOutlet="videoTpl; context: { media: media }"></ng-container>
        }
      }
    }
  }
</div>

<ng-template #imageTpl let-media="media">
  <mb-image class="contain" [isLightboxMedia]="true" [media]="media"></mb-image>
</ng-template>

<ng-template #documentTpl let-media="media">
  @if (media.filetypeName === 'PDF') {
    <mb-pdf-preview [url]="media.original.url" [title]="media.title"></mb-pdf-preview>
  }
  @if (media.filetypeName !== 'PDF') {
    <mb-document-preview
      [title]="media.title"
      [filetypeName]="media.filetypeName"
      [url]="media.original.url"
      [showOpenButton]="!isPreMedia"
    ></mb-document-preview>
  }
</ng-template>

<ng-template #audioTpl let-media="media">
  <mb-audio [media]="media"></mb-audio>
</ng-template>

<ng-template #videoTpl let-media="media">
  <mb-video [controls]="true" [allowPictureInPicture]="false" [media]="media"></mb-video>
</ng-template>
